// This controller only handles the visual switching of checked and unchecked states, so that this is seen by the user as fast as possible.
// Other stuff that can happen slower is handled by the ajax action javascript (complete.js and uncomplete.js)

import { Controller } from 'stimulus'

export default class extends Controller {

  static targets = ['complete_link', 'uncomplete_link']

  complete(event) {
    const step = event.target.closest('.step');
    let taskId;

    if (step) {
      taskId = step.dataset.taskId;
      step.classList.add('complete');
    }

    const close_done = event.target.closest('.close_done');
    const closeDoneEl = close_done || document.querySelector(`.close_done[data-task-id='${taskId}']`);

    if (closeDoneEl) {
      closeDoneEl.classList.add('hidden');
    }

    // hide clicked checkbox-wrap
    const wrap = event.target.closest('.checkbox-wrap');
    if (wrap) wrap.classList.add('hidden');

    // show uncomplete checkbox-wrap (only if it exists)
    if (this.hasUncomplete_linkTarget) {
      const nextWrap = this.uncomplete_linkTarget.closest('.checkbox-wrap');
      if (nextWrap) nextWrap.classList.remove('hidden');
    }
  }

  uncomplete(event) {
    const step = event.target.closest('.step');
    let taskId;

    if (step) {
      taskId = step.dataset.taskId;
      step.classList.remove('complete');
    }

    const close_done = event.target.closest('.close_done');
    const closeDoneEl = close_done || document.querySelector(`.close_done[data-task-id='${taskId}']`);

    if (closeDoneEl) {
      closeDoneEl.classList.remove('hidden');
    }

    // hide clicked checkbox-wrap
    const wrap = event.target.closest('.checkbox-wrap');
    if (wrap) {
      wrap.classList.add('hidden');
    }

    // show complete checkbox-wrap (only if it exists)
    if (this.hasComplete_linkTarget) {
      const nextWrap = this.complete_linkTarget.closest('.checkbox-wrap');
      if (nextWrap) {
        nextWrap.classList.remove('hidden');
      }
    }
  }
}
